
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//shared modules
import { FrameModule } from '@app-frame';
import { CxFormsModule } from '@forms';
import { MessageBusModule } from '@event-bus';
import { ConverterModule } from '@converter';
import { LocalisationModule } from '@localisation';
import { ConfigurationModule } from '@config';
import { UserModule, UserService } from '@user';
import { RoutingExtensionModule } from '@routing';
import { HttpExtensionModule } from '@http';
import { AuthModule } from '@auth';
import { SiteInfoModule } from '@site-info';
//import { WebpictureEditorModule } from '@webpicture-editor';
import { UiButtonsModule } from '@ui-buttons';
import { UiAreasModule } from '@ui-areas';
import { UiMessagesModule } from '@ui-messages';
import { LoaderModule } from '@loader';
import { NavigationModule } from '@navigation';
import { DatapointsModule } from '@datapoints';
import { FavouritesModule } from '@favourites';
import { DashboardsModule } from '@dashboards';
import { PlantsModule } from '@plants';
import { NotificationModule } from '@notification';
import { TenantModule } from '@tenant';
import { WinFormsModule, WinFormsContentScreen } from '@winforms';
import { LoginModule } from '@login';
import { UiPartsModule } from '@ui-parts';
import { ThemesModule } from '@themes';
import { ResponsiveModule } from '@responsive';
import { ScreenModule } from '@screen';
import { UrlModule } from '@url';
import { DatabaseModule } from '@database';
import { ToolsModule } from '@tools';
import { ApplicationSetModule } from '@application-sets';
import { WebAccessModule } from '@web-access';
import { SchedulerModule } from '@scheduler';

import { UserRolesModule } from '@user-roles';
import { TitleManagerModule } from '@title-manager';
import { ImageModule } from '@image';
import { FilesModule } from '@files';
import { RegistrationModule } from '@registration';
import { ChangePasswordModul } from '@change-password';
import { UiFormatModule } from '@ui-format';
import { WorkflowModule } from '@workflow';
import { PrivilegesModule } from '@privileges';
import { PreregisterModule } from '@preregister';
import { CheckerModule } from '@check';
import { StateModule } from '@state';
import { BillingModule } from '@billing';
import { MainRoutes } from './routes/main.routes';
import { HttpClientModule } from '@angular/common/http';
import { ReleaseNotesModule } from '@release-notes';
import { M2MRouterModule } from '@m2m-router';
import { MapModule } from '@maps';
import { InternalReleaseNotesModule } from '@internal-release-notes';
import { UpgradeModule } from '@upgrade';
import { AlarmModule } from '@alarm';
import { HubModule } from '@hub';
import { LicenseModule } from '@license';
import { ThirdPartyAppsModule } from '@third-party-apps';
import { CookieModule } from '@cookie';
import { SystemModule } from '@systems';

//components
import { AppComponent } from './app.component';
import { ApiDocumentationModule } from '@api-documentation';
import { ScriptingEditorModule } from 'modules/scripting-editor-module';
import { BenchmarkDashboardModule } from '@benchmark-dashboard';
import { AppContainerModule } from '@app-container';
import { NodeRedModule } from '@node-red';
import { ProtoPagesModule } from '@proto-pages';
import { TrendviewerModule } from '@trendviewer';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule.forRoot(MainRoutes, { useHash: true }),
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        WinFormsModule,
        CxFormsModule,
        FrameModule,
        RoutingExtensionModule.forRoot({ winFormsComponent: WinFormsContentScreen }),
        HttpExtensionModule,
        AuthModule,
        MessageBusModule,
        ConverterModule,
        LocalisationModule,
        ConfigurationModule,
        UserModule,
        SiteInfoModule,
        UiButtonsModule,
        UiAreasModule,
        UiMessagesModule,
        UiPartsModule,
        LoaderModule,
        NavigationModule,
        DatapointsModule,
        FavouritesModule,
        DashboardsModule,
        PlantsModule,
        NotificationModule,
        WebAccessModule,
        SchedulerModule,
        TenantModule,
        LoginModule,
        TitleManagerModule,
        ThemesModule,
        ResponsiveModule,
        ScreenModule,
        UrlModule,
        DatabaseModule,
        ToolsModule,
        ApplicationSetModule,
        UserRolesModule,
        ImageModule,
        FilesModule,
        RegistrationModule,
        ChangePasswordModul,
        UiFormatModule,
        WorkflowModule,
        PrivilegesModule,
        PreregisterModule,
        CheckerModule,
        StateModule,
        M2MRouterModule,
        BillingModule,
        ReleaseNotesModule,
        MapModule,
        InternalReleaseNotesModule,
        UpgradeModule,
        AlarmModule,
        HubModule,
        LicenseModule,
        ThirdPartyAppsModule,
        CookieModule,
        SystemModule,
        ApiDocumentationModule,
        ScriptingEditorModule,
        BenchmarkDashboardModule,
        AppContainerModule,
        NodeRedModule,
        ProtoPagesModule,
        TrendviewerModule
    ],
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas : [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}